module.exports = __webpack_public_path__ + "mainassets/img/navbar-x.bec240c3.svg";